/* eslint-disable react/no-unescaped-entities */
import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import myContext from "../../../Context/myContext";
import toast from "react-hot-toast";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth, fireDB } from "../../../firebase/FirebaseConfig";
import Loader from "../../loader/Loader";
import { collection, getDocs, query, where } from "firebase/firestore";
import 'bootstrap-icons/font/bootstrap-icons.css'; // Import Bootstrap Icons

const Login = () => {
    const context = useContext(myContext);
    const { loading, setLoading } = context;
    const navigate = useNavigate();

    // User Login State 
    const [userLogin, setUserLogin] = useState({
        email: "",
        password: ""
    });

    // Password visibility state
    const [showPassword, setShowPassword] = useState(false);

    // Toggle password visibility
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    /**========================================================================
     *                          User Login Function 
     *========================================================================**/
    const userLoginFunction = async () => {
        // Validation
        if (userLogin.email === "" || userLogin.password === "") {
            toast.error("All fields are required");
            return; // Exit early if validation fails
        }

        setLoading(true);
        try {
            console.log("Attempting to login...");
            const userCredential = await signInWithEmailAndPassword(auth, userLogin.email, userLogin.password);
            console.log("User credential:", userCredential);

            // Fetch user details from Firestore
            const userQuery = query(
                collection(fireDB, "user"),
                where('uid', '==', userCredential.user.uid)
            );
            const querySnapshot = await getDocs(userQuery);
            console.log("Query snapshot:", querySnapshot);

            let user = null;
            querySnapshot.forEach((doc) => {
                user = doc.data();
                console.log("User data:", user);
            });

            if (user) {
                localStorage.setItem("users", JSON.stringify(user));
                setUserLogin({
                    email: "",
                    password: ""
                });
                toast.success("Login successful");
                
                if (user.role === "user") {
                    navigate('/home');
                } else {
                    navigate('/admin-dashboard');
                }
            } else {
                toast.error("User not found");
            }
        } catch (error) {
            console.error("Login error:", error);
            toast.error("Login failed: " + (error.message || "An unknown error occurred"));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='d-flex justify-content-center align-items-center vh-100'>
            {loading && <Loader />}
            {/* Login Form */}
            <div className="bg-light p-4 border rounded shadow-sm" style={{ width: '350px' }}>
                {/* Top Heading */}
                <h2 className='text-center text-primary mb-4'>
                    Login
                </h2>

                {/* Email Input */}
                <div className="mb-3">
                    <input
                        type="email"
                        name="email"
                        placeholder='Email Address'
                        value={userLogin.email}
                        onChange={(e) => setUserLogin({ ...userLogin, email: e.target.value })}
                        className='form-control'
                    />
                </div>

                {/* Password Input */}
                <div className="mb-3 input-group">
                    <input
                        type={showPassword ? "text" : "password"}
                        placeholder='Password'
                        value={userLogin.password}
                        onChange={(e) => setUserLogin({ ...userLogin, password: e.target.value })}
                        className='form-control'
                    />
                    <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={togglePasswordVisibility}
                    >
                        <i className={showPassword ? "bi bi-eye-slash" : "bi bi-eye"}></i>
                    </button>
                </div>

                {/* Login Button */}
                <div className="mb-3">
                    <button
                        type='button'
                        onClick={userLoginFunction}
                        className='btn btn-primary w-100'
                    >
                        Login
                    </button>
                </div>

                {/* Link to Signup */}
                <div className="text-center">
                    <h6 className='text-dark'>
                        Don't have an account? <Link className='text-primary' to='/signup'>Signup</Link>
                    </h6>
                </div>
            </div>
        </div>
    );
}

export default Login;
